import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AppDataService } from 'lib/app-data.service.js';
import { AuthService } from 'lib/auth/auth.service.js';
import { PlatformService } from 'lib/platform/index.js';
import { RequestService } from 'lib/request/request.service.js';
import { ScreenService } from 'lib/screen/index.js';
import { AzureSearchService } from 'lib/search/client/azure-search.service.js';
import { AppLogService } from 'lib/services/app-log.service.js';
import { NavigateService } from 'lib/services/navigate.service.js';
import { SharedService } from 'lib/services/shared.service.js';
import { StorageService } from 'lib/services/storage.service.js';
import { WindowScrollService } from 'lib/services/window-scroll.service.js';
import { DialogService } from 'lib/ui/dialog/index.js';
import { LayoutUiService } from 'lib/ui/layout/layout-ui.service.js';
import { ThemeService } from 'lib/ui/theme/theme.service.js';
import { TooltipService } from 'lib/ui/tooltip/tooltip.service.js';
import { TrialService } from '../../../lib/trial/trial.service.js';
import { HttpService } from '../http/http.service.js';
import { LinkedItemsService } from '../http/linked-items.service.js';
import { LayoutService } from '../layout/services/layout-service.js';
import { AppNotificationService } from '../services/app-notification.service.js';
import { AppVersionService } from '../services/app-version.service.js';
import { AssetsService } from '../services/assets.service.js';
import { TimeService } from '../services/time.service.js';
import { CoreAppService } from './core-app.service.js';

@Injectable({
	providedIn: 'root'
})
export class CoreAppComponentDependencies {
	constructor(
		public readonly coreAppService: CoreAppService,
		public readonly appDataService: AppDataService,
		public readonly tooltipService: TooltipService,
		public readonly platformService: PlatformService,
		public readonly injector: Injector,
		public readonly authService: AuthService,
		public readonly router: Router,
		public readonly navigateService: NavigateService,
		public readonly httpService: HttpService,
		public readonly screenService: ScreenService,
		public readonly notificationService: AppNotificationService,
		public readonly timeService: TimeService,
		public readonly dialogService: DialogService,
		public readonly layoutUiService: LayoutUiService,
		public readonly linkedItemsService: LinkedItemsService,
		public readonly sharedService: SharedService,
		public readonly azureSearchService: AzureSearchService,
		public readonly windowScrollService: WindowScrollService,
		public readonly assetsService: AssetsService,
		public readonly storageService: StorageService,
		public readonly logService: AppLogService,
		public readonly trialService: TrialService,
		public readonly themeService: ThemeService,
		public readonly appVersionService: AppVersionService,
		public readonly layoutService: LayoutService,
		public readonly requestService: RequestService
	) {}
}
